import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { Row,Col, Card, Form, Button } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import {Api} from '../../../utils/Variables';
import axios from 'axios';
import {message, Tooltip, Skeleton, Space, Drawer} from 'antd';

import PsContext from '../../context/PsContext';

class Payments extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showLoader: false,
			dataList: [],
			dataView: [],
			editData: [],
			showSubMenu: false,
		}
	
		this.handleSubMenuClose = this.handleSubMenuClose.bind(this);
		this.handleSubMenuOpen = this.handleSubMenuOpen.bind(this);
		this.handleDeleteClick = this.handleDeleteClick.bind(this);
		this.confirmDelete = this.confirmDelete.bind(this);
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'Payments',
			back: true,
			to: '/app',
		});
		this.loadData();
	}
		
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	loadData(){
		try{
			this.setState({
				dataView: [],
				dataList: [],
				showLoader: true,
			});
			axios.get(Api.Url+'v1/customers?api='+this.context.state.api).then(res=>{
				if(res['data'].status=='1'){
					this.setState({
						dataList: res['data'].data,
						dataView: res['data'].data,						
					});
				}
				this.setState({showLoader: false});
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	handleSubMenuOpen(record){
		this.setState({
			editData: record,
			showSubMenu: true,
		});
	}
	
	handleSubMenuClose(){
		this.setState({
			editData: [],
			showSubMenu: false,
		});
	}
	
	getUserInfo(field){
		try{
			var d = this.state.editData;
			return d[field];
		}
		catch(er){ }
	}
	
	handleDeleteClick(){
		var $this = this;
		$.confirm({
			title: 'Confirm',
			content: 'Do you want to delete?',
			buttons: {
				Yes:  function(){
					$this.confirmDelete();
				},
				No: function(){ }
			}
		});
	}
	
	confirmDelete(){
		try{
			this.setState({showLoader: true});
			var form = new FormData();
			var uId = this.getUserInfo('id');
			form.append('api', this.context.state.api);
			form.append('i__id', uId);
			axios.post(Api.Url+'v1/customer/remove', form).then(res=>{
				if(res['data'].status=='1'){
					message.success(res['data'].message || 'Success');
					var d = this.state.dataList;
					var index = d.findIndex(function(obj){
						return(obj.id==uId);
					});
					if(index>=-1)
						d.splice(index,1);
					this.setState({
						dataList: d,
						dataView: d,
						showLoader: false,
						editData: [],
						showSubMenu: false,
					});
				}
				else{
					message.error(res['data'].message || 'Error');
					this.setState({showLoader: false});
				}
			});
		}
		catch(error){
			console.log(error);
			this.setState({showLoader: false});
		}
	}
	
	
	render(){

		return(
		<div className="container" >
			<div data-aos="fade" >
			
				<Row>
					<Col md={10} >
					
					</Col>
					<Col md={2}>
						<Link to="/app/payment/new" className="btn btn-primary" >
							<i className="icofont-plus"></i> New Payment Entry
						</Link>
					</Col>
				</Row>
			
				
			</div>	
			</div>
		);
	}
	
}
export default Payments;
